<template>
  <tr>
    <td><input type="text" class="form-control" v-model="mark.subjectName" /></td>
    <td><input type="text" class="form-control" v-model="mark.maxMarks" /></td>
    <td><input type="text" class="form-control" v-model="mark.marksObtained" /></td>
    <td v-if="markentryConf.termConf.cognateFieldEnabled"><input type="checkbox" class="form-control"  v-model="mark.isCognate" /></td>
    <td v-if="markentryConf.termConf.isLanguageFieldEnabled"><input type="checkbox" class="form-control" v-model="mark.isLanguage" /></td>
  </tr>
</template>

<script>
export default {
 name: "single-termwise-markentry-row",
 props:{
     subjectNo:Number,
     markentryConf:Object
 },
 data(){
     return {
         mark:{
         sem:"",
         subjectName:"",
         isCognate:false,
         isLanguage:false,
         marksObtained:"",
         maxMarks:""
         }
     }
 },
 watch:{
     mark(){
         if(this.mark.subjectName){
             const response={};
             response.subjectNo=this.subjectNo;
             response.mark=this.mark;
             console.log('emit');
             this.$emit('add-mark',this.mark);
         }
         else{
              this.$emit('remove-mark',this.mark);
         }
     }
 }
}
</script>

<style>

</style>